<script>
	import {mapGetters} from 'vuex'
	import {db, increment} from '@/js/firebase'

	export default {
		name: 'JoinSession',
		data() {
			return {
				componentName: 'JoinSession',
				code: '',
				secret: '',
				error: null,
			}
		},
		components: {},
		props: [],
		computed: {
			...mapGetters(['session', 'account']),
		},
		methods: {
			joinSession(id) {
				this.error = null
				let session = db
					.collection('session')
					.where('code', '==', +this.code)
					.where('secret', '==', this.secret)
					.where('userCount', '==', 1)
				console.log(session)
				session
					.get()
					.then(querySnapshot => {
						console.log(querySnapshot)
						console.log(this.code, this.secret)
						querySnapshot.forEach(function(doc) {
							console.log(doc.id, ' => ', doc.data())
							db.collection('session')
								.doc(doc.id)
								.set(
									{
										codeExpires: new Date(),
										users: {
											[this.acccount.uid]: new Date(),
										},
										userCount: increment(1),
									},
									{merge: true}
								)
								.then(resp => {
									console.log({resp})
								})
								.catch(err => {
									console.log({err})
								})
						})
					})
					.catch(err => {
						console.log({err})
					})

				// session.onSnapshot(doc => {
				// 	console.log('snap', doc)
				// 	if (doc.empty) {
				// 		return (this.error = 'Invalid code or secret')
				// 	}
				// 	this.$store.dispatch('setSession', doc.data())
				// 	this.$route.params.id = doc.id
				// 	let route = {
				// 		name: 'sesson',
				// 		params: {id: doc.id},
				// 	}
				// 	this.$router.replace(route)
				// })
			},
			validateSession() {
				this.error = null
				let session = db
					.collection('session')
					.where('code', '==', this.code)
					.where('secret', '==', this.secret)
				session.get(async doc => {
					console.log('snap', doc)
					if (doc.empty) {
						return (this.error = 'Invalid code or secret')
					}
					await this.joinSession(doc.id)

					this.$store.dispatch('setSession', doc.data())
					this.$route.params.id = doc.id
					let route = {
						name: 'sesson',
						params: {id: doc.id},
					}
					this.$router.replace(route)
				})
			},
		},
		mounted() {
			// Called after the instance has just been mounted where el is replaced by the newly created vm.el. If the root instance is mounted to an in-document element, vm.el will also be in-document when mounted is called.
			this.$nextTick(() => {
				// console.log('<JoinSession> is ready and attached to the dom', this)
			})
		},
	}
</script>
<!-- ******************************************************************* -->
<template>
	<div class="JoinSession">
		<v-card>
			<v-card-title> </v-card-title>
			<v-card-text>
				<p>
					Your partner would have provided you 2 pieces of information for you
					to join their ToDo. A 6 digit number and a secret word or phrase. If
					you have both of those, please enter those below.
				</p>
				<p>
					{{ error }}
				</p>
				<v-text-field label="Code" v-model="code" type="number"> </v-text-field>

				<v-text-field type="password" label="Secret" v-model="secret">
				</v-text-field>
			</v-card-text>
			<v-card-actions>
				<v-btn @click="joinSession" flat color="orange">Join Todo</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>
<!-- ******************************************************************* -->
<style scoped>
	.JoinSession {
	}
</style>
